module.exports = __webpack_public_path__ + "static/media/goods6_1.07895ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods6_1.png
// module id = 1235
// module chunks = 0